import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { isSameDay } from 'date-fns';

import { findClosestDateAfter, findClosestDateBefore } from '@src/app/utils/date';
import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-vehicle-details-routes-days-switch',
  templateUrl: './vehicle-details-routes-days-switch.component.html',
  styleUrls: ['./vehicle-details-routes-days-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleDetailsRoutesDaysSwitchComponent {

  @Output() public onShowCalendar: EventEmitter<void> = new EventEmitter();
  @Output() public onChangeDate: EventEmitter<Date[]> = new EventEmitter();

  @Input() public initialDate: Date[] = [];

  @Input('selectedDateCalendar') public set setSelectedDateCalendar(data: Date[]) {
    this._selectedDateCalendar = [...data];
    this.ifDateDayIsSame = isSameDay(data[0], data[1]);
  }

  public ifDateDayIsSame: boolean = true;
  public _selectedDateCalendar: Date[] = [];

  public today = new Date();
  public readonly langauge: string = this.languageService.current;

  constructor(
    private languageService: LanguageService,
  ) { }

  public get getSelectedDate(): Date | Date[] {
    return this._selectedDateCalendar.length ? this._selectedDateCalendar : this.initialDate[1];
  }

  private get rangeDateFrom(): Date {
    return this._selectedDateCalendar[0];
  }

  private get rangeDateTo(): Date {
    return this._selectedDateCalendar[1];
  }

  public setPreviousDate(): void {
    const date = this.getSelectedDate;
    const a = findClosestDateBefore(Array.isArray(date) ? this.rangeDateFrom : date);
    this._selectedDateCalendar = [a, a];
    this.ifDateDayIsSame = true;
    this.onChangeDate.emit(this._selectedDateCalendar);
  }

  public setNextDate(): void {
    const date = this.getSelectedDate;
    const a = findClosestDateAfter(Array.isArray(date) ? this.rangeDateTo : date);
    this._selectedDateCalendar = [a, a];
    this.ifDateDayIsSame = true;
    this.onChangeDate.emit(this._selectedDateCalendar);
  }

  public isMaxDate(): boolean {
    const date = this.getSelectedDate;
    return isSameDay(Array.isArray(date) ?  this.rangeDateTo : date, new Date());
  }
}
